import { defineStore } from 'pinia'

export const useOrdersStore = defineStore('orders', {
  state: () => {
    return {
      viewOrders: false,
      orders: [],
      statusOptions: [
        {
          label: 'En Proceso',
          id: 1,
        },
        {
          label: 'Finalizado',
          id: 2,
        },
        {
          label: 'Cancelado',
          id: 3,
        },
      ],
    }
  },

  actions: {
    showOrders(orders: []) {
      this.viewOrders = true
      this.orders = orders
    },

    hideOrders() {
      this.viewOrders = false
      this.orders = []
    },
  },
})
